import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacySk7() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`VII.`}
            <br />
            {`Autorské právo a licenčné dohody`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Používateľ (subjekt údajov) berie na vedomie, že všetok obsah webovej stránky, t. j. najmä audio a video obsah, fotografie, grafické diela a  ďalšie prvky nachádzajúce sa na webovej stránke alebo dostupné v rámci služby sú chránené autorským právom.`}</li>
            <li>{`Databázy nachádzajúce sa na webovej stránke alebo dostupné v rámci služby sú chránené osobitným právom zhotoviteľa databázy, ktorým je poskytovateľ.`}</li>
            <li>{`V prípade, že nie je s poskytovateľom dohodnuté písomne inak, môže k oprávnenému použitiu autorských diel či databáz používateľom dôjsť iba v rámci používateľského rozhrania služby.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={4} className={sList}>
            <li>{`Používateľ nie je oprávnený obsah webovej stránky či služby kopírovať, ukladať či duplikovať, spojovať s inými autorskými dielami či s autorskými dielami nakladať inak, než ich použitím v rámci služby. Používateľ nie je oprávnený obchádzať technické prostriedky určené na ochranu obsahu.`}</li>
            <li>{`Používateľ berie na vedomie, že počítačové programy tvoriace webovú stránku sú chránené autorským právom. Používateľ sa zaväzuje, že nebude vykonávať žiadnu činnosť, ktorá by mohla jemu alebo tretím osobám umožniť neoprávnene zasahovať či používať počítačové programy, kde je vykonávateľom majetkových práv poskytovateľ.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacySk7;
